(function ($) {

    Drupal.behaviors.stickyInpage = {
        attach: function (context) {
            let elm = document.querySelector('.js-nav-inpage', context),
                mainnav = document.querySelector('.navbar--top'),
                body = document.querySelector('body'),
                elmOffset = (elm) ? elm.getBoundingClientRect().top :"",
                mainnavHeight = mainnav.offsetHeight;

            if(!elm){
                return false;
            }

            if(window.pageYOffset >= 0){
                elmOffset += window.pageYOffset;
            }

            window.addEventListener('scroll', classHandler);

            function classHandler(){
                if((window.pageYOffset + mainnavHeight) >= elmOffset){
                    elm.classList.add('scrolled');
                    body.classList.add('inpage-fixed');
                }else{
                    elm.classList.remove('scrolled');
                    body.classList.remove('inpage-fixed');
                }
            }


        }
    }
}());